import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class PaymentService {
    public urlBase = '/cncipays/';
    public urlBaseOxxo = 'https://api.cnci.mx/cncipays/';
    public urlTodito = '/toditopay/';
    constructor(public http: HttpClient) { }

    generatePaymentLeague(data): Observable<any>{
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        //return this.http.post<any>(this.urlBase + 'send', data);
        return this.http.post(this.urlBase + 'send', data, { headers, responseType: 'text'});
    }

    searchOxxoReference(data): Observable<any>{
        return this.http.get(this.urlBaseOxxo + 'searchOxxoReference?curp=' + data.curp + '&who=' + data.who + '&concept=' + data.concept + '&amount=' + data.amount + '&matricula=' + data.matricula + '&transaction=' + data.transaction + '&student_name=' + data.student_name
        + '&description=' + data.description + '&email=' + data.email + '&id_runway=' + data.id_runway + '&want_invoice=' + data.want_invoice + '&rfc=' + data.rfc + '&business_name=' + data.business_name);
    }

    payckta(data): Observable<any>{
        return this.http.post(this.urlBaseOxxo + 'payckta', data);
    }

    payByTodito(data): Observable<any>{
        return this.http.post<any>(this.urlTodito + 'send', data);
    }

    createCheckoutSession(data: any): Observable<any> {
        return this.http.post<any>(this.urlBase + 'conekta/createCheckoutSession', data);
    }

    saveSubscription(data: any): Observable<any> {
        return this.http.post<any>(this.urlBase + 'conekta/saveSubscription', data);
    }

    getSubscriptions(registration: string, businessId: number): Observable<any> {
        return this.http.get<any>(
            this.urlBase + `conekta/getSubscriptions?registration=${registration}&business_id=${businessId}`
        );
    }

    cancelSubscription(id: number, registration: string): Observable<any> {
        return this.http.delete<any>(this.urlBase + `conekta/cancelSubscription/${id}?registration=${registration}`);
    }

    reactivateSubscription(id: number, registration: string): Observable<any> {
        return this.http.post<any>(this.urlBase + `conekta/reactivateSubscription/${id}`, { registration });
    }

    confirmPayment(data: { transaction: string, order_id: string, status: 'APROBADA' | 'DECLINADA' }): Observable<any> {
        return this.http.post<any>(this.urlBase + 'conekta/confirmPayment', data);
    }

    getSubscriptionHistory(id: number, registration: string): Observable<any> {
        return this.http.get<any>(
            this.urlBase + `conekta/subscriptionHistory/${id}?registration=${registration}`
        );
    }
}
